import { defineMessages } from 'react-intl';

export default defineMessages({
  creditToTrainline: {
    id: 'CreditTrainlineRow.creditToTrainline',
    defaultMessage: 'Trainline Credit (TVTOD)',
  },
});
